import { createAsyncThunk } from '@reduxjs/toolkit';
import { FlightField } from './interface';
import { flightsActions } from './index';
export const FLIGHT_NUMBER_MAX_LENGTH = 4;
const validateFlightNumber = (value) => {
    const trimmedValue = value.trim();
    if (!trimmedValue) {
        return { error: 'Обязательное поле' };
    }
    return { error: null };
};
export const setFlightNumber = createAsyncThunk('flights/setFlightNumber', async ({ _uuid, value }, thunkApi) => {
    const transformedValue = value.replace(/\D/g, '').trim();
    const { error } = validateFlightNumber(transformedValue);
    thunkApi.dispatch(flightsActions._setFlightField({
        _uuid,
        field: FlightField.flightNumber,
        value: transformedValue,
    }));
    thunkApi.dispatch(flightsActions._setFlightFieldError({
        _uuid,
        field: FlightField.flightNumber,
        error,
    }));
});
